import React from 'react';
import EnhancedReferencePersonsList from './EnhancedReferencePersonsList';

/**
 * Legacy component wrapper for backwards compatibility
 * Redirects to the enhanced version
 */
const ReferencePersonsList = (props) => {
  return <EnhancedReferencePersonsList {...props} />;
};

export default ReferencePersonsList;
